import { useBaseListView } from '@/common/view/useBaseListView';
import { useCrudActions } from '@/common/view/useCrudActions';
import { bonusService } from '@/services/bonus';

export function useBonusLoginList() {
    const { list, total, fetchList } = useBaseListView({ request: bonusService.login.list });

    const actions = {
        remove: useCrudActions().confirmAndRemove({
            request: bonusService.login.remove,
            onSuccess: () => fetchList()
        })
    };

    return { list, total, fetchList, actions };
}
